<i18n src="@/i18n/components/event-edit-form.json"></i18n>

<template>
  <div class="modal-card has-text-left">
    <header class="modal-card-head">
      <p class="modal-card-title">{{ $t('editEvent') }}</p>
      <button class="delete" @click="onClose"></button>
    </header>
    <section class="modal-card-body">

      <div class="field">
        <label class="label">{{ $t('eventName') }}</label>
        <div class="control">
          <input class="input is-large" placeholder="Event name" v-model="eventName">
        </div>
      </div>

    </section>
    <footer class="modal-card-foot">
      <div class="buttons">
        <button class="button is-success" @click="updateEvent" :class="{ 'is-loading': isUpdating }" :disabled="isLoading">{{ $t('edit') }}</button>
        <button class="button is-danger" @click="deleteEvent" :class="{ 'is-loading': isDeleting }" :disabled="isLoading || !isInitiator()">
          <span class="icon is-small"><i class="fa fa-exclamation-triangle"></i></span>
          <span>{{ $t('deleteEvent') }}</span>
        </button>
        <button class="button" @click="onClose">{{ $t('cancel') }}</button>
      </div>
    </footer>
  </div>
</template>

<script>
  import gql from 'graphql-tag'
  import { bus } from '@/shared/bus'

  const updateEvent = gql`
    mutation updateEvent($eventId: ID!, $eventName: String!) {
      updateEvent(id: $eventId, name: $eventName) {
        id
        name
      }
    }
  `

  export default {
    name: 'event-edit-form',
    props: ['event', 'on-close'],
    data () {
      return {
        eventName: this.event.name,
        isLoading: false,
        isUpdating: false,
        isDeleting: false
      }
    },
    methods: {
      updateEvent () {
        this.isLoading = true
        this.isUpdating = true

        this.$apollo.mutate({
          mutation: updateEvent,
          variables: {
            eventId: this.event.id,
            eventName: this.eventName
          }
        }).then(() => {
          bus.$emit('toast:new', {type: 'success', message: this.$t('eventUpdated')})

          this.onClose()
        }).catch((error) => {
          bus.$emit('toast:new', {type: 'danger'})
          this.$ga && this.$ga.exception(error.message || error)
        }).then(() => {
          this.isLoading = false
          this.isUpdating = false
        })
      },
      deleteEvent () {
        this.isLoading = true
        this.isDeleting = true

        // Delete users
        let usersToDeleteIds = []
        for (let participant of this.event.participants) {
          if (participant.attendedEvents.length === 1 && participant.attendedEvents[0].id === this.event.id) {
            usersToDeleteIds.push(participant.id)
          }
        }

        let deleteUserQueries = ''
        if (usersToDeleteIds.length > 0) {
          for (let id of usersToDeleteIds) {
            deleteUserQueries += id + ': deleteUser(id: "' + id + '") {id}'
          }
        }

        // Delete items
        let itemsToDeleteIds = []
        for (let participant of this.event.participants) {
          for (let item of participant.items) {
            itemsToDeleteIds.push(item.id)
          }
        }

        let deleteItemQueries = ''
        if (itemsToDeleteIds.length > 0) {
          for (let id of itemsToDeleteIds) {
            deleteItemQueries += id + ': deleteItem(id: "' + id + '") {id}'
          }
        }

        let deleteEvent = gql`
          mutation deleteEvent($eventId: ID!) {
            deleteEvent(id: $eventId) {
              id
            }
            ${deleteUserQueries}
            ${deleteItemQueries}
          }
        `

        this.$apollo.mutate({
          mutation: deleteEvent,
          variables: {
            eventId: this.event.id,
            userId: this.event.initiator.id
          }
        }).then(() => {
          this.$toast.open({
            message: this.$t('eventDeleted'),
            position: 'is-bottom',
            type: 'is-success'
          })

          this.$router.push({name: 'CreateEvent'})
        }).catch((error) => {
          bus.$emit('toast:new', {type: 'danger'})
          this.$ga && this.$ga.exception(error.message || error)
        }).then(() => {
          this.isLoading = false
          this.isDeleting = false
        })
      },
      isInitiator () {
        return localStorage.getItem('userId') && localStorage.getItem('userId') === this.event.initiator.id
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/EventEditForm.vue